import { __generator } from "tslib";
import { take, call, put, select, race } from 'redux-saga/effects';
import { changeCurrentMediaSource, setCurrentFolderId, fetchMoreGallections, fetchMoreGallectionsDone, reloadStashStreamDone, } from '../actions';
import { STREAM__WITH_OFFSET__FETCH_SUCCESS, STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE, } from '../../Stream/withOffset/actions';
import { getCurrentMediaSource, getTopLevelGallections, getCurrentFolderId, } from '../selectors';
import { getGallectionDeviationStreamId } from '../helpers';
import { withOffset } from '../../Stream';
import { MediaSourceType } from '../types';
function getOrLoadGallections() {
    var gallections, done, payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getTopLevelGallections)];
            case 1:
                gallections = _a.sent();
                if (!(!gallections || gallections.length === 0)) return [3 /*break*/, 7];
                // gallections for the currentMediaSource have not yet been loaded, load them
                return [4 /*yield*/, put(fetchMoreGallections())];
            case 2:
                // gallections for the currentMediaSource have not yet been loaded, load them
                _a.sent();
                done = false;
                _a.label = 3;
            case 3:
                if (!!done) return [3 /*break*/, 5];
                return [4 /*yield*/, take(fetchMoreGallectionsDone)];
            case 4:
                payload = (_a.sent()).payload;
                done = (payload === null || payload === void 0 ? void 0 : payload.type) === MediaSourceType.STASH;
                return [3 /*break*/, 3];
            case 5: return [4 /*yield*/, select(getTopLevelGallections)];
            case 6:
                gallections = _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/, gallections];
        }
    });
}
export function reloadStashStream() {
    var currentMediaSource, currentFolderId, gallections, streamId, done, _a, fetchSuccess, fetchSuccessDeduped, actionStreamId;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getCurrentMediaSource)];
            case 1:
                currentMediaSource = _b.sent();
                return [4 /*yield*/, select(getCurrentFolderId)];
            case 2:
                currentFolderId = _b.sent();
                if (!(currentMediaSource !== MediaSourceType.STASH)) return [3 /*break*/, 7];
                // change the media source to stash
                return [4 /*yield*/, put(changeCurrentMediaSource(MediaSourceType.STASH))];
            case 3:
                // change the media source to stash
                _b.sent();
                return [4 /*yield*/, call(getOrLoadGallections)];
            case 4:
                gallections = _b.sent();
                if (!!gallections.length) return [3 /*break*/, 6];
                // still no folders? everything is terrible, let's crash gracefully
                return [4 /*yield*/, put(reloadStashStreamDone())];
            case 5:
                // still no folders? everything is terrible, let's crash gracefully
                _b.sent();
                return [2 /*return*/];
            case 6:
                // First stash folder is the "Featured" folder which contains items uploaded to the stash root
                currentFolderId = gallections[0].folderId;
                _b.label = 7;
            case 7:
                if (!currentFolderId) return [3 /*break*/, 12];
                streamId = getGallectionDeviationStreamId(MediaSourceType.STASH, currentFolderId);
                return [4 /*yield*/, put(withOffset.actions.deleteStream(streamId))];
            case 8:
                _b.sent();
                // Load this folder id
                return [4 /*yield*/, put(setCurrentFolderId(currentFolderId))];
            case 9:
                // Load this folder id
                _b.sent();
                done = false;
                _b.label = 10;
            case 10:
                if (!!done) return [3 /*break*/, 12];
                return [4 /*yield*/, race({
                        fetchSuccess: take(STREAM__WITH_OFFSET__FETCH_SUCCESS),
                        fetchSuccessDeduped: take(STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE),
                    })];
            case 11:
                _a = _b.sent(), fetchSuccess = _a.fetchSuccess, fetchSuccessDeduped = _a.fetchSuccessDeduped;
                actionStreamId = (fetchSuccess === null || fetchSuccess === void 0 ? void 0 : fetchSuccess.streamId) || (fetchSuccessDeduped === null || fetchSuccessDeduped === void 0 ? void 0 : fetchSuccessDeduped.streamId);
                done = actionStreamId === streamId;
                return [3 /*break*/, 10];
            case 12: return [4 /*yield*/, put(reloadStashStreamDone())];
            case 13:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export default reloadStashStream;
//# sourceMappingURL=reloadStashStream.js.map